import firestore from "./firebase";
import { doc, updateDoc } from "firebase/firestore";

const actionUpdateCheckpoint = async(document_id, level, checkpoints, checkpointUpdate) => {    

    const washingtonRef = doc(firestore, "checkpoints", document_id);
    const checkpointParse = JSON.parse(JSON.stringify(checkpoints));    
    await updateDoc(washingtonRef, { 
        [level]: {
            ...checkpointParse[level],
            ...checkpointUpdate
        } 
    });

    return({
        level: level, 
        update_checkpoint: checkpointUpdate 
    });
}

export default actionUpdateCheckpoint;